import React from 'react'
import './About.css'

function AboutUs() {
  return (
    <>
     <div className='container-fluid mt-100'>
      <div className='row'>
        <div className='col-md-12 position-relative p-0'>
           <img src='./About.jpg' className='img-fluid'/>
        </div>
      </div>
     </div>
     <div className='container'>
      <div className='row'>
        <div className='col-md-12'>
          <h1 className='heading'>About <span>Us</span></h1>
          <table className="contactus-table">
              <tbody>
                <tr>
                  <th>Company Name</th>
                  <td>Legions Travel Service Japan</td>
                </tr>
                <tr>
                  <th>Company Name(Japanese)</th>
                  <td>レジオンストラベルサービスジャパン株式会社</td>
                </tr>
                <tr>
                  <th>Address</th>
                  <td>
                  Fussa, Fussa, Tokyo 197-0011
                   
                    {/* <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3239.765467858167!2d139.60673581520118!3d35.70738863614446!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018ee082de32f13%3A0x74c2437830c4ee03!2z44CSMTY3LTAwNDMg5p2x5Lqs6YO95p2J5Lim5Yy65LiK6I2777yT5LiB55uu77yR77yQ4oiS77yR77yQ!5e0!3m2!1sja!2sjp!4v1552790955865"
                      width="100%"
                      height="250"
                      frameborder="0"
                      allowfullscreen="allowfullscreen"
                    ></iframe> */}
                  </td>
                </tr>
                <tr>
                  <th>TEL</th>
                  <td>+81-03-6826-0514</td>
                </tr>
                <tr>
                  <th>FAX</th>
                  <td>+81-</td>
                </tr>
                <tr>
                  <th>Representative</th>
                  <td>Mr Amit Rana </td>
                </tr>
                <tr>
                  <th>Established</th>
                  <td>4th March 2024</td>
                </tr>
                <tr>
                  <th>Capital</th>
                  <td>10,000,00 JPY</td>
                </tr>
                <tr>
                  <th>Business Area</th>
                  <td>Japan Land Arrangements │ Tour Operator</td>
                </tr>
                
                <tr>
                  <th>Major Banks</th>
                  <td>MUFG Bank, Ltd.</td>
                </tr>
                <tr>
                  <th></th>
                  <td></td>
                </tr>
              </tbody>
            </table>
        </div>
      </div>
     </div>
    </>
  )
}

export default AboutUs
